export default {
  currentPassword: '',
  newPassword: '',
  newPasswordConfirmation: '',
  captchaVerified: false
};



// WEBPACK FOOTER //
// ./src/containers/MyAccount/ChangePassword/formValues.js